// extracted by mini-css-extract-plugin
module.exports = {"TitleWrapper":"Title_TitleWrapper__IbLeP","left":"Title_left__Xe46E","MainTitle":"Title_MainTitle__r5z7a","Icon":"Title_Icon__KWDm5"};